"use client";

import React from "react";
import { Phone, Mail, ArrowRight, MapPin, Facebook, Instagram, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const currentYear = new Date().getFullYear();
  return <footer id="footer" ref={ref} className={`relative bg-secondary text-foreground border-t border-border/40 pt-20 pb-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="block transition-opacity hover:opacity-80">
              <img src="https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/image_13cva9x5.webp" alt="Lora Serramenti" className="w-auto object-contain !h-[90px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-light">
              Sicurezza, design e innovazione italiana.
              <br />
              Trasformiamo i tuoi spazi con serramenti di alta qualità e stile senza tempo.
            </p>
            <div className="flex gap-5 mt-2">
              <Link to="https://www.instagram.com/loraserramenti?igsh=MTg1NDZ0bXpzcWM5dQ%3D%3D&utm_source=qr" newTab aria-label="Instagram" className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="https://www.facebook.com/share/1GVNCsA9EE/?mibextid=LQQJ4d" newTab aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110">
                <Facebook className="w-5 h-5" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-wider">Contatti Rapidi</h3>
            <div className="flex flex-col space-y-4">
              <Link to="tel:+393349255303" className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-300">
                <div className="p-2 rounded-full bg-secondary group-hover:bg-primary/10 transition-colors duration-300">
                  <Phone className="w-4 h-4" />
                </div>
                <span className="font-medium text-sm">+39 334 9255303</span>
              </Link>
              
              <Link to="mailto:info@loraserramenti.it" className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-300">
                <div className="p-2 rounded-full bg-secondary group-hover:bg-primary/10 transition-colors duration-300">
                  <Mail className="w-4 h-4" />
                </div>
                <span className="font-medium text-sm">info@loraserramenti.it</span>
              </Link>

              <Link to="https://wa.me/393349255303" newTab className="group inline-flex items-center gap-3 text-[#25D366] font-medium hover:opacity-80 transition-all duration-300 mt-2">
                <div className="relative flex items-center justify-center w-8 h-8">
                   <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-20"></span>
                   <div className="relative p-1.5 rounded-full bg-[#25D366]/10 text-[#25D366]">
                     <MessageCircle className="w-5 h-5" />
                   </div>
                </div>
                <span className="text-sm group-hover:translate-x-1 transition-transform duration-300">Chatta su WhatsApp</span>
              </Link>
            </div>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-wider">Richiedi Preventivo</h3>
            <p className="text-muted-foreground text-sm font-light leading-relaxed">
              Hai un progetto in mente? Parliamone insieme per trovare la soluzione perfetta per la tua casa.
            </p>
            <Button asChild className="w-full sm:w-auto rounded-full bg-primary hover:bg-primary/90 text-white shadow-lg hover:shadow-primary/25 transition-all duration-300 hover:-translate-y-1 active:scale-95">
              <Link to="/ContactsPage">
                Richiedi ora
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-wider">Dove Siamo</h3>
            <div className="flex items-start gap-3 text-muted-foreground text-sm font-light">
              <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-primary" />
              <address className="not-italic leading-relaxed">
                <span className="font-medium text-foreground">LORA SERRAMENTI</span>
                <br />
                Via Paolo Braccini 37/b
                <br />
                10073 Ciriè (TO), Italia
              </address>
            </div>
            
            <div className="pt-2">
               
            </div>
          </div>
        </div>

        <Separator className="bg-border/60 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground font-light">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6 text-center md:text-left">
            <span>&copy; {currentYear} Lora Serramenti. Tutti i diritti riservati. P.IVA 12345678901</span>
            <span className="hidden md:inline text-border">|</span>
            <div className="flex gap-4 justify-center">
                <Link to="#" className="hover:text-foreground transition-colors duration-200">Privacy Policy</Link>
                <Link to="#" className="hover:text-foreground transition-colors duration-200">Cookie Policy</Link>
            </div>
          </div>
          <div className="text-center md:text-right opacity-60 hover:opacity-100 transition-opacity duration-300">
            Designed with precision.
          </div>
        </div>
      </div>
    </footer>;
}